export function deviceLabel(): string {
  if (typeof navigator === 'undefined') return 'web';
  const agent = navigator.userAgent || '';
  if (/android/i.test(agent)) return 'android';
  if (/iphone|ipad|ipod/i.test(agent)) return 'ios';
  return 'web';
}
